<template>
  <div class="content-wrap">
    <div class="each" v-for="(item, index) in data.content" :key="index">
      <div class="each-wrap">
        <img class="each-img" :src="item.imgUrl" alt="">

        <div class="content-wrapper" :style="{'--height': data.height}">
          <div class="title" :class="{'titleBlue': isBlue}">
            {{ item.teamName }}
            <template v-if="item.worksname">
            - {{ item.worksname }}
            </template>
          </div>
          <div class="desc" v-html="item.desc" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'data',
    'isBlue'
  ]
}
</script>

<style scoped lang='scss'>

$gap: 15px;
.content-wrap {
  display: flex; flex-wrap: wrap;
  align-items: stretch;
  margin: -$gap;
  background: $bgGrey;
}

.each {
  display: flex;
  flex-direction: column;

  @include mobile {
    width: 100%;
    margin-bottom: 20px;
  }
}

.each-wrap {
  flex-grow: 1;
  box-sizing: border-box;
  padding: 0 10px 10px;
  @include mobile {
    height: auto;
  }
}

.each-img {
  width: 384px; height: 252px;

  @include mobile {
    width: 100%;
  }
}

.content-wrapper {
  width: 384px; height: var(--height);
  padding: 24px 32px 26px;
  background: #FFFFFF;

  @include mobile {
    width: 100%; height: auto;
    padding: 18px 22px 24px;
  }
}

.title {
  color: #000000;
  font-size: 18px; font-weight: 600;
  line-height: 32px;

  @include mobile {
    margin-bottom: 8px;
    font-size: 16px;
    line-height: 22px;
  }
}

.titleBlue {
  background: linear-gradient(90deg, #3976FF 0%, rgba(216, 216, 216, 0) 100%);
}

.desc {
  color: #828A92;
  font-size: 15px; font-weight: 400;
  line-height: 32px;

  @include mobile {
    font-size: 13px; font-weight: 400;
    line-height: 24px;
  }
}
</style>
